import axios from 'axios'
import queryClient from './queryClient'
import toasterService from './toasterService'
// import {queryCache} from 'react-query'

export const SERVER_HOST = 'https://teamalan-server.herokuapp.com'
// export const SERVER_HOST = 'http://localhost:8000'

export const apiAxios = axios.create({
  baseURL: `${SERVER_HOST}/api/`
})

apiAxios.interceptors.request.use(
  function (config) {
    const token = getLocalAuthToken()
    if (token) {
      config.headers['Authorization'] = `Token ${token}`
    }
    return config
  }
)

apiAxios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    let status = error?.response?.status

    toasterService.sendErrors(error)

    if (status === 401 || status === 403) {
      // history.push('/login')
      queryClient.clear()
    }

    return Promise.reject(error)
  }
)

export const openBlobApi = async (endpoint, method = 'get', data = null) => {
  return await apiAxios({
    method: 'get',
    url: endpoint,
    data: data,
    responseType: 'blob'
  })
    .then((res) => {
      const file = new Blob([res.data], { type: 'application/pdf' })
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL)
    })
    .catch(async (error) => {
      if (error.response) {
        try {
          const { data } = error.response

          const fileReader = new FileReader()
          const file = await new Promise((resolve, reject) => {
            fileReader.onerror = () => {
              fileReader.abort()
              reject(new Error('Problem parsing file'))
            }

            fileReader.onload = () => {
              resolve(fileReader.result)
            }

            fileReader.readAsText(data)
          })

          // @ts-ignore
          error = { response: { data: JSON.parse(file) } }
        } catch (readError) {
          error = 'Arquivo inválido'
        }
      } else {
        error = 'Arquivo inválido'
      }

      return Promise.reject(error)
    })
}

export const getLocalAuthToken = () => localStorage.getItem('app:token')
export const setLocalAuthToken = (token) => localStorage.setItem('app:token', token)